export class UserAuthUtil {

  static getUserOnPremise() {
    return this.getAuthResult()?.idTokenClaims?.onpremisesuserprincipalname || "";
  }

  static getAccessToken() {
    return this.getAuthResult()?.accessToken || "";
  }

  static getUserName() {
    return this.getAuthResult()?.account?.username || "";
  }

  static getFullName() {
    return this.getAuthResult()?.account?.name || "";
  }

  static getIdToken() {
    return this.getAuthResult()?.idToken || "";
  }

  private static getAuthResult() {
    const storage = localStorage.getItem(
      import.meta.env.VITE_APP_AZURE_AUTH_RESULT,
    );
    return storage ? JSON.parse(storage) : null;
  };
}
